import { getTopicScoreColor, TopicStat } from "../../constants/dashboardStats";
import TopicPracticeButton from "../TopicPracticeButton/TopicPracticeButton";
import "./TopicBreakdownRow.scss";

type TopicBreakdownRowProps = {
  rank: number;
  topic: TopicStat;
  onPractice: (topic: TopicStat) => void;
};

const getRankClass = (rank: number): string => {
  if (rank === 1) return "topic-breakdown-row__rank--first";
  if (rank === 2 || rank === 3) return "topic-breakdown-row__rank--podium";
  return "";
};

const TopicBreakdownRow = ({ rank, topic, onPractice }: TopicBreakdownRowProps) => {
  const color = getTopicScoreColor(topic.score);
  const rankClass = getRankClass(rank);

  return (
    <div className="topic-breakdown-row">
      <div className="topic-breakdown-row__left">
        <span className={`topic-breakdown-row__rank${rankClass ? ` ${rankClass}` : ""}`}>
          {rank}
        </span>
        <span className="topic-breakdown-row__name">{topic.name}</span>
      </div>
      <div className="topic-breakdown-row__right">
        <div className="topic-breakdown-row__bar-wrap">
          <div
            className="topic-breakdown-row__bar"
            style={{ width: `${topic.score}%`, background: color }}
          />
        </div>
        <span className="topic-breakdown-row__score" style={{ color }}>
          {topic.score}%
        </span>
        <span className="topic-breakdown-row__questions">{topic.questionsDone} q</span>
        <TopicPracticeButton topicName={topic.name} onClick={() => onPractice(topic)} />
      </div>
    </div>
  );
};

export default TopicBreakdownRow;
